export const Config = {
	END_POINT: "https://api.osdepym.demo.tolber.io/api/",
	BASE_URL: "https://osdepym.demo.tolber.io/",
	// END_POINT: 'http://api-tolber.com/api/',
	// BASE_URL: 'http://tolber.com/adm/portal-socios',
	PHOTO_DEFAULT_USER: "/assets/img/users/default.jpg",
	DEFAULT_VALUE: "",
	PROVIDER_ID: 3,
	GOOGLE_MAPS_API_KEY: "AIzaSyAzUFSVW28kMXA-C_G0W3Gv2VTU8oDMgxg",
	GOOGLE_RECAPTCHA_KEY: "6LcLoOIZAAAAAGiQ3oWlxb5W_vbXMd42GrrxrlaO",
};
